import { Component } from "@angular/core";
import { RpMobileKeyboardService } from "projects/mydocma-rp/src/lib/rp-common/mobile-keyboard/mobile-keyboard.service";
@Component({
    selector: "mydocma-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent {
    constructor(mobileKeyboardService: RpMobileKeyboardService) {
        mobileKeyboardService.init();
    }

}
